<div class="wrap">

  <div class="detail-head-box">
    <div class="head-box type-region">다른 지역, 같은 말</div>
    <div class="menu-box">
      <a class="close-btn" (click)="onClosePopup()"></a>
    </div>
  </div>

  <div #container
       class="detail-body-box">


    <div #mapBox
         class="region-map-box"
         [style.padding-bottom.px]="mapBottomPadding">

      <div class="region-other-item"
           *ngIf="word"
           (click)="onOpenLinkWord($event, word.id)">
        <div class="subject">표준말</div>
        <div class="con">
          <app-dialect-disp [word]="word"></app-dialect-disp>
        </div>
      </div>

      <div *ngFor="let region1 of listRegion"
           class="region-box"
           [style.top]="region1.pos2.top + '%'"
           [style.left]="region1.pos2.left + '%'">{{ region1.text }}</div>

      <!-- 추가 아이템 -->
      <div #regionBubble
           class="region-item-box region-pos-{{ GetRegion2CssPos(dialect.region2) }}"
           *ngFor="let dialect of listRegionBox"
           (click)="onOpenLinkDialect($event, dialect.ids_txt)">
        <div class="item-box">
          <div class="top-box">{{ dialect.names_txt }}</div>
          <div class="bottom-box type-{{ GetRegion2Css(dialect.region2) }}">{{ GetRegion2Name(dialect.region2) }}</div>
        </div>
      </div>

      <img src="assets/img/img_region_bg.png" alt="이미지" (load)="scheduleBubbleLayout()">

    </div>

  </div>

</div>
